import _ from 'lodash'
import { z } from 'zod'

// updating this model?  don't break current data!
// see _UpdatingSchemas.md
export const RDrugDisposal = z.object({
	Name: z.optional(z.nullable(z.string())),
	NameAdditional: z.optional(z.nullable(z.string())),
	Address: z.optional(z.nullable(z.string())),
	Distance_MI: z.optional(z.nullable(z.number())),
})

export type DrugDisposal = z.infer<typeof RDrugDisposal>
